import locokitFr from '@locokit/i18n/fr.json'

export default {
  capel: {
    components: {
      dataTable: {
        selectButtonLabel: 'Ouvre le détail',
        removeButtonLabel: 'Supprime la ligne',
        duplicateButtonLabel: 'Duplique la ligne'
      },
      formRecord: {
        formWithErrorLabel: 'Votre formulaire présente des erreurs :'
      },
      deleteConfirmDialog: {
        message: 'Êtes vous sûr•e de vouloir supprimer cette ligne ?',
        header: "Confirmez l'action",
        rejectLabel: 'Annuler',
        acceptLabel: 'Supprimer'
      },
      duplicateConfirmDialog: {
        message: 'Êtes vous sûr•e de vouloir dupliquer cette ligne ?',
        header: "Confirmez l'action",
        rejectLabel: 'Annuler',
        acceptLabel: 'Dupliquer'
      },
      translateButton: {
        label: 'Langue'
      },
      statusOnline: {
        online: 'En ligne',
        offline: 'Hors ligne'
      },
      dropdownButton: {
        label: 'Export',
        labelCsv: 'Export CSV',
        labelXls: 'Export XLSX'
      }
    },
    routes: {
      index: {
        title: 'Authentification',
        signup: "Vous n'avez pas encore de compte ? Inscrivez vous sur {link}.",
        signupLinkLabel: 'le site de capel',
        signupLinkHref: 'https://capel.portcros-parcnational.fr/inscription'
      },
      lostpassword: {
        title: 'Mot de passe, où es tu ?',
        subtitle: [
          'Vous avez perdu votre mot de passe ?',
          'Renseignez votre email pour recevoir un mail avec un lien temporaire. Cliquez dessus, et vous pourrez changer votre mot de passe !'
        ],

        sendResetOK:
          "Mail envoyé ! Merci de vérifier vos mails, d'ouvrir le mail que nous venons de vous envoyer, et d'ouvrir le lien indiqué.",
        homelink: "Retour à la page d'accueil"
      },
      resetpassword: {
        title: 'Réinitialisation du mot de passe',
        subtitle: 'Vous pouvez réinitialiser votre mot de passe.',
        resetOK:
          'Mot de passe réinitialisé. Vous pouvez vous connecter avec ce nouveau mot de passe.',
        homelink: "Retour à la page d'accueil",
        labelSubmit: 'Réinitialiser le mot de passe'
      },
      home: {
        title: 'Accueil',
        welcomeMessage: 'Bonjour {0}, bienvenue sur la plateforme CaPeL.',
        chooseStructure:
          'Veuillez choisir une structure à laquelle vous êtes rattaché :'
      },
      profile: {
        title: 'Profil',
        pref: 'Préférences',
        lang: 'Langue',
        logoutButtonLabel: 'Déconnexion',
        sync: 'Statut de la synchronisation',
        dataUnsyncNb: 'Données en attente de synchro',
        noGroup: 'Pas de groupe correspondant',
        logoutConfirm: {
          message:
            'Toutes vos données ne sont pas synchronisées avec le serveur. Si vous vous déconnectez, ces données seront définitivement perdues.',
          header: 'Êtes vous sûr•e de vouloir vous déconnecter ?',
          rejectLabel: 'Rester connecté•e',
          acceptLabel: 'Confirmer la déconnexion'
        }
      },
      about: {
        title: 'À propos',
        tuto: {
          title: "Comment installer l'application CaPeL ?",
          step1:
            "Pour ajouter l'application sur votre écran d'accueil, commencez par aller sur le site web à l'aide de votre navigateur mobile.",
          step2:
            'Dans le menu de votre navigateur (ici, Firefox), vous pouvez cliquer sur "Ajouter à l\'écran d\'accueil"',
          step3:
            "Le navigateur va ajouter une nouvelle icone sur votre écran d'accueil. En cliquant dessus, vous pourrez démarrer l'application."
        }
      },
      dives: {
        displayOffline: 'Afficher les données hors ligne'
      },
      groups: {
        welcomeMessage:
          'Vous pouvez accéder aux différentes pages via la barre de navigation de gauche.'
      }
    },
    groups: {
      '46a3022d-775b-48c8-8fdc-05ee8b612f19': 'Plongeurs individuels'
    },
    pages: {
      /**
       * Plongeurs individuels
       */
      '4802390a-dc60-42e4-9d95-8da03adc8332': 'Déclarer une plongée',
      'd1d5538d-1a89-4fae-9f0c-168929246580': 'Mes informations',
      'c1be69d2-a1a1-42dd-852c-cbc69a61201c': 'Mes plongées',
      '2409b750-288d-43a5-b695-48c9efceb196': 'Signer les règlements',
      '4002c4b3-1692-4254-8f9c-8f62ee056bb1': 'Mes statistiques', // normalement indispo en mobile
      'b7b5ffac-ca95-4223-b9f6-0c2f6775bba5': 'Mes sites de plongées',
      /**
       * Structures de plongées
       */
      'd5e94e2d-7283-485b-9051-4b6020f0f89d': 'Mes plongées',
      'd1f09edc-637c-4121-8167-de4d858ee7ef': 'Déclarer une plongée',
      '238d3224-6f10-4f18-beb6-c3f47503fd14': 'Mes informations',
      'a40733e3-0876-4c54-8c62-d819f9423553': 'Signer les règlements',
      'dbcdb220-5f0f-4211-b56f-8df88e136d63': 'Mes sites de plongées',
      '5ef1e357-5216-42e0-805f-899f54447e40': 'Mes statistiques'
    },
    tables: {
      dive: 'Plongées'
    },
    views: {},
    fields: {
      /**
       * View 42a912cc-8092-4bc4-a693-1202a98fb047 (plongée)
       */
      '31715499-a088-4f07-a892-9bf1b82e43d9': 'Observations',
      '6d4b0019-e7b8-44f5-a149-560a1fe85a05': 'Spot',
      '7b1002cf-8869-4d99-bd87-908f8c699939': 'Profil utilisateur',
      'f34b0527-0d41-48d9-bdbd-ef154fe41a89': 'Groupe profil utilisateur',
      '95b7a4f0-9448-4f92-a60c-51699b99f256': 'Utilisateur profil (user)',
      'f1afdce6-d0a6-4e0e-8671-fc2828ad62e5': 'Type de profil',
      '17151d1b-2414-4f45-a870-e74c532a8487': 'Bateau utilisé',
      '7de25c38-90c7-4565-a242-fa632e97b8b7': 'Date et heure de début',
      'ada3a864-6a55-4c4c-972a-0cccb989bbb4': 'Ciel',
      '3860d95d-8043-4898-92fe-78b855e4cff2': "Température de l'air",
      'b7cd0121-ef79-487e-a64f-16ca3d26894d': "Température de l'eau",
      '276931ae-a7ce-4070-b57b-2fe1f87f3486': 'Type de plongée',
      'ad3823a0-798c-4533-88e5-34aff8090109': 'État de la mer',
      'f3cfb9a1-7ba2-48c7-b61c-f147294b8853': 'Coordonnées GPS Spot',
      'bb58a84f-ad6e-4691-b3b4-5b12c1a04b0b': 'Type du spot',
      '02cb1cea-1213-417a-bea6-566b63d38fda':
        'Autre structure accompagnante (si non trouvée)',
      '7634f2f3-65c5-4535-b5cc-0f6a26fb036d': 'Ressenti fréquentation',
      '70207683-f6b3-459a-8c81-192c3a122028': 'Durée de la plongée en minutes',
      '7782bc53-373e-4263-8f47-7d5d24a762c9': 'Vent',
      '57f3cfb7-3f68-4d82-9c2a-24b635d38cd5': 'Force vent',
      '3e6610e4-d33d-4c92-b340-c79ad2be8e11': "Visibilité sous l'eau",
      '74d5e1f6-8f2b-41e1-afb7-6f7d03b34515': 'Structure accompagnante',
      /**
       * View f9f26f67-906a-4270-a02d-5ac5b2550487 (plongée pour SP)
       */
      '46a2b752-b932-4fcb-830a-2643d92c77ea': 'Exploration (nb plongeurs)',
      '1499a9a1-2e66-4fb1-816e-f01b08850b0c': 'Technique (nb plongeurs)',
      '4a6776ee-23fb-45d6-ae7f-b8d0370f472b': 'Baptême (nb plongeurs)',
      '4db32f17-5a21-4631-bc96-0a0d187a944a': 'Rando palmée (nb plongeurs)',
      'a7177ed7-e4d8-41e4-9e48-c63143609391': 'Apnée (nb plongeurs)',

      /**
       * View 6dffd1f7-2305-4efa-86c5-7bfc8d78b3fa (profil)
       */
      '3dd6ee01-1ac5-460f-8493-5cfd4d00ede2': 'Adresse',
      'ca5da03e-5339-49cf-b85e-a1d2f3591e58': 'Code postal',
      'caa08f00-6473-41fb-b296-d7ba84fda61f': 'Code postal - Ville',
      '3b136f3d-1ada-48d9-9269-1164cfb17f5b': 'Coordonnées GPS',
      '76c9bfdc-65f3-4493-b870-6e341764d594': 'Inscription finalisée',
      '805f9150-85bb-4d1d-b2f7-9f4a32bcd923':
        'Je donne mon accord pour apparaître sur la carte CaPeL des structures',
      'a59ed9ed-c770-4809-86ab-c603e6505a48': 'Ne possède pas de bateaux',
      '4392a17a-439f-491e-ac7e-e02b8758b15a': 'Nom du responsable',
      'e6a1237f-6572-4b43-94cf-2d6479701138': 'Nom',
      '01d4b6a8-fac5-4c06-b004-dd5c956550a8': 'Pays',
      'ac4cdbf5-917d-4617-b708-03f4ef6e14a5': 'Prénom',
      'f0039978-d841-49f5-b1b7-b01ac37f77ce': 'Site web',
      'e298f951-dc04-4c2e-b32d-fdd4d09a77dc': 'Téléphone principal',
      '24301d5b-6392-457f-b4fc-5847b0fbbfbf': 'Téléphone secondaire',
      '16b9033c-6c84-4039-884f-723e6d7b826a': 'Type',
      'd1dac070-c92c-4258-b83f-fa938702a1be': 'Ville',

      /**
       * View f983f6bc-aef8-4be1-84df-d0575b29bdd0 (bâteaux)
       */
      '84da40f5-e089-4004-a852-f6059b050b54': 'Immatriculation',
      'e09b9cb0-0d7a-4266-a2d8-f60df6c1eb56': 'Nom du bateau',
      '769ccb4e-71b3-437b-8ef9-1627a74302ba': 'Propriété',
      'f55c2485-9256-4ac4-918b-a390943bebb8': 'Entreprise de location',
      'd3a4746d-892c-4d01-9d87-0af45db633f4': 'Code postal - Ville',
      '7b63abc8-5c9d-47ed-a4cc-c1379efde110': 'Rattaché à',
      'afc6e1a0-41ca-414d-99f7-efe98c988910': 'Type de profil',
      /**
       * View bf963648-8282-4d7b-8e2a-ddbf0d76619d / 042f806d-de57-46d1-aacc-491fe321b51c (signature de règlement)
       */
      '478de360-bd6d-48c1-bb03-8f711227571a':
        "Je m'engage à respecter la réglementation en cœur de Parc",
      'a5c47952-21a9-4db4-9f9f-1fb8ce93de71':
        "Je m'engage à respecter les conditions du règlement de plongée",
      'e5e061fd-7d4d-4d65-b756-9615131d6411':
        "Je m'engage ainsi à remplir mes données de plongée",
      '140054df-a8ec-467d-85fc-8b95daaed565':
        "Nombre de plongées de l'année passée dans le coeur de Port-Cros",
      '384654ae-b646-4b76-b67a-cd82d8be5671':
        "Nombre de plongées de l'année passée dans le coeur de Porquerolles",
      '0d763fd3-aa8f-41ab-9a7e-b946957ba2e5':
        "Nombre de plongées de l'année passée dans l'Aire Maritime Adjacente",
      '0de2234f-14ea-4d89-b35b-acef99a5bf38': 'Règlement PDF signé',
      '7e376e9e-362b-4bc4-b151-497a7193d8e5': 'Date de signature du règlement',
      '8e22ef53-7e0e-447e-b455-4d8023ab4941': 'Profil utilisateur',
      'd0689dcb-e722-4418-84dc-a7720c8b26c8': 'Signataire',
      'd21a5e94-2606-4153-89a9-a96f3b44ac97': "Numéro d'autorisation",
      'b70ba85b-7e7f-4073-9c96-36f20fc8b84e': 'Signé',
      'd316793c-d5ab-487e-8c56-94303ca6a721': 'Type de profil',
      'fb9f9464-1750-4f71-babd-05450ce62407': 'Structure de plongée',
      'b25b4a6e-c2b5-441a-a566-4e4f9941ad1b': 'Règlement'
    },
    selectOptions: {
      /**
       * Table plongée
       */
      /** ada3a864-6a55-4c4c-972a-0cccb989bbb4 : ciel / weather */
      '574b2b73-4a41-4ff3-8fbb-f9cee8f80ebd': 'Ensoleillé',
      '702e1741-271b-45c1-88af-77aa91330fd8': 'Pluvieux',
      'b251d467-3b02-490f-9fab-af5c2ff9c67e': 'Orageux',
      'bd1b65b5-4224-4eba-97b2-8c7fa7694971': 'Nuageux',
      /* 276931ae-a7ce-4070-b57b-2fe1f87f3486 : Type de plongée */
      '13604341-ee3a-4a9e-9f7a-ecb3eded9cc6': 'Technique',
      '27796a1b-b8db-4a9a-9b41-3f0cba62ec8d': 'Rando palmée',
      '51c74f21-ecd1-4f03-903e-60700099a1a1': 'Baptême',
      '7e3394fa-051a-4a50-8289-2327ed08c591': 'Exploration',
      'c1f05ae3-afa8-43d0-b2de-7e4d5ec90658': 'Apnée',
      /* ad3823a0-798c-4533-88e5-34aff8090109 : État de la mer / Sea conditions */
      '0d8757d9-26e9-427b-9cf2-073161722a6d': 'Forte',
      '75390ace-ff00-4d4f-801c-d6f813fd0ccb': 'Peu agitée',
      '8a32f220-0362-45b7-ad48-ba5b143fb04f': 'Belle',
      '93d8a888-deeb-4c74-a204-7b3f442bf173': 'Très forte',
      'a224d7cc-9998-4995-b3a5-dd54a08eda19': 'Agitée',
      /* 7634f2f3-65c5-4535-b5cc-0f6a26fb036d : Ressenti fréquentation / Impression of dive traffic */
      '21d82838-e393-4409-b4dc-d578439dc471': 'Bon',
      '74dcad28-f445-4132-9ca6-18225f4685fd': 'Trop fréquenté',
      '85b8f273-792a-4698-ac3b-30a2cfeee324': 'Moyen',
      /* 7782bc53-373e-4263-8f47-7d5d24a762c9 : Vent / Wind */
      '056278b8-d433-46a7-bba5-56e9156cc033': 'Est',
      '0c786d30-bf2a-4f02-b13d-704507b37e13': 'Nord-Est',
      '3768e0fa-4225-4043-8e5a-f40f566ff34e': 'Sud-Est',
      '3c984a69-2ad2-4070-aaa1-481ddb1ffa62': 'Nord',
      '8e2c22da-5573-46ad-b5de-4d222878567c': 'Nord-Ouest',
      '9880e8c0-b58f-4d53-b6ae-6d5cb5ca9730': 'Sud',
      'cf695cd0-8596-4a63-85b2-356217bd4b29': 'Ouest',
      'e39359f3-f2e6-457e-ad72-cce3171fd6ba': 'Sud-Ouest',
      /* 57f3cfb7-3f68-4d82-9c2a-24b635d38cd5 : Force vent / Wind force (Beaufort) */
      '04b9473d-31df-48b3-9288-d4c1d1f87185': '3',
      '1a773bc2-06af-4917-9f67-efea40652ced': '6',
      '325b0b88-8515-437a-a518-a2708676f44d': '12',
      '4657db92-d2c5-46ce-a3f9-4741c9ad8172': '9',
      '4f3a642d-2b78-49be-b3bc-83c4f2e7bcc7': '10',
      '713e810e-0bab-45e2-99ab-f4d77c6768af': '11',
      '726e9fba-de01-4678-8cc6-270f963f19f4': '2',
      '74bbc1b1-4853-4b09-926d-0b80c9b2d530': '4',
      '82ececc4-0bb4-4503-b2dc-b86f7ddb5c46': '1',
      '966e2597-d95a-4b15-9de8-1b0ad859e20c': '7',
      '96aae942-84c7-4af4-a26c-159e420fc06a': '0',
      'b9ed93dd-7ebc-41c3-a538-1f9a697606ce': '5',
      'bca82ede-3426-4d42-bda8-97e59d328f97': '8',
      /* 3e6610e4-d33d-4c92-b340-c79ad2be8e11 : Visibilité sous l'eau / Underwater visibility */
      '22ac0979-4be5-4208-b4a8-c4cddc5d6847': '5 à 10m',
      '7226d91c-6927-45b5-b998-42daf48538df': '10 à 15m',
      '8f17f3d6-e07a-41d8-a40d-ccd6ed75a1aa': '0 à 5m',
      'dbd35cd1-2107-4405-8c41-d90efd05b763': 'plus de 20m',
      'e55299a7-8b15-4af7-bb8e-5026b91a3fca': '15 à 20m',

      /**
       * Table spot de plongée e6ef266a-3d25-4740-b3da-9a13eb51f97c
       */
      /* 367b6249-a3e2-4a3e-be3b-9b5decbb580a : Type de site de plongée */
      '2b1901bc-e596-4d94-974e-f0dddc045105': 'Naturel',
      '152f88c8-fb96-4ea7-8299-be7e4de9aa70': 'Épave',
      /**
       * Table bateaux 485e908a-7e67-49df-a472-53273602ffd1
       */
      /* 769ccb4e-71b3-437b-8ef9-1627a74302ba : Propriété / Location */
      '82a57cef-feec-4af9-8384-19c106eb5abe': 'Propriétaire',
      '99a417e4-c30a-41d6-a59a-035d331a683f': 'Location à un professionnel',
      'caf3b37c-186b-4d3c-ab94-09fc199bb16b': 'Location à un particulier',

      /**
       * Table profil
       */
      /* : Type de profil */
      '25a3a052-df34-4ef7-b802-772c68be38cd': 'Plongeur individuel',
      '9f294876-24bb-4081-8a59-d52d2c7e9d92': 'Structure de plongée'
    },
    general: {
      loading: 'Chargement...'
    },
    validations: {
      messages: {
        required: "Le champ '{field}' est requis.",
        email:
          "L'email du champ '{field}' ne correspond pas au format attendu.",
        regex: "Le champ '{field}' ne correspond pas au format attendu.",
        confirmed:
          "Les mots de passe du champ '{field}' et du champ '{target}' ne sont pas identiques.",
        isFalseOrOtherTrue:
          "Le champ '{field}' ne peut être coché que si le champ '{target}' l'est également.",
        minDate: "La date du champ '{field}' doit être après {fromDate}.",
        dateValid:
          "La date du champ '{field}' ne correspond pas au format attendu.",
        reference:
          "La valeur du champ '{field}' est invalide : veuillez sélectionner une valeur dans la liste."
      }
    }
  },
  locokit: locokitFr.locokit
}
